import React from "react";
import "./Button.css";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner";

export type ButtonTheme =
  | "primary"
  | "red"
  | "white"
  | "blue"
  | "yellow"
  | "green"
  | "danger"
  | "warning"
  | "default";

export type ButtonSize = "small" | "medium";

interface Props {
  label?: string;
  onClick?: () => void;
  className?: string | undefined;
  children?: any;
  theme?: ButtonTheme;
  iconName?: string;
  disabled?: boolean;
  outlined?: boolean;
  size?: ButtonSize;
  loading?: boolean;
}

function Button(props: Props) {
  const {
    onClick = () => {},
    label = "",
    className = "",
    children,
    theme = "primary",
    iconName = "",
    disabled = false,
    outlined = false,
    size = "medium",
    loading = false,
  } = props;

  const handleClick = () => {
    if (!disabled && !loading) {
      onClick();
    }
  };

  const getButtonClasses = () => {
    const classes = ["buttonProps", "generalBtn"];
    
    if (outlined) {
      classes.push(`${theme}-outlined`);
    } else {
      classes.push(theme);
    }

    classes.push(size);
    classes.push(className);
    
    if (disabled || loading) {
      classes.push("disableBtn");
    }

    return classes.join(" ");
  };

  return (
    <button
      className={getButtonClasses()}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <>
          <SlSpinner style={{ fontSize: "14px" }} />
          {label}
        </>
      ) : (
        <>
          {label}
          {children}
          {iconName.length > 0 && (
            <SlIcon name={iconName} className="button-icon" />
          )}
        </>
      )}
    </button>
  );
}

export default Button;
